import React from 'react';
import Slider from "react-slick";
import ParticleBackground from "../../../components/ParticleBackground/ParticleBackground";

const HomeTwoTestimonial = () => {
   // slick setting
   const settings = {
      autoplay: false,
      autoplaySpeed: 10000,
      dots: true,
      fade: false,
      arrows: false,

   }
   const testimonialData = [
      {
         id: 1,
         name: 'Manufacturing Operations Director',
         title: 'Industrial Manufacturing',
         text: "Vector Technologies revolutionized our production workflow. Their automation experts designed a custom solution that reduced machine downtime by 32%. The team's professionalism and technical depth truly stand out in the industry."
      },
      {
         id: 2,
         name: 'Senior Plant Manager',
         title: 'Packaging Facility',
         text: "We upgraded our entire control system through Vector Technologies, and the results exceeded expectations. Everything—from the initial assessment to commissioning—was handled with precision. Their reliability and expertise make them our long-term automation partner."
      },
      {
         id: 3,
         name: 'Engineering Lead',
         title: 'Energy Sector',
         text: "Vector Technologies delivered a flawless integration of our SCADA and PLC systems. Their attention to detail, documentation quality, and operator training were exceptional. We now operate with improved safety, visibility, and efficiency."
      },
      {
         id: 4,
         name: 'Production Supervisor',
         title: 'Food Processing Industry',
         text: "Their automation solutions helped us significantly increase throughput while maintaining strict compliance standards. Vector's engineers worked side-by-side with us, ensuring a smooth transition with minimal downtime."
      },
      {
         id: 5,
         name: 'Maintenance Supervisor',
         title: 'Industrial Operations',
         text: "The support team at Vector Technologies is phenomenal. They always respond quickly and go beyond troubleshooting — they help prevent future issues. Their service contracts are worth every penny."
      },
      {
         id: 6,
         name: 'Director of Operations',
         title: 'Industrial Manufacturing',
         text: "Vector Technologies didn't just install equipment; they built a scalable foundation for our factory. Their custom control panels and system upgrades aligned perfectly with our long-term operational goals."
      },
      {
         id: 7,
         name: 'IT/OT Systems Manager',
         title: 'Digital Transformation',
         text: "Our plant's digital transformation was only possible because of Vector Technologies. Their understanding of industrial networking and cybersecurity is unmatched. We now have a secure, modern, and connected operation."
      },
      {
         id: 8,
         name: 'Production Engineer',
         title: 'Manufacturing',
         text: "The onboarding and training process provided by Vector Technologies was outstanding. They made complex systems easy for our entire team to understand. Their clarity and patience make them a preferred vendor for us."
      },
      {
         id: 9,
         name: 'CEO',
         title: 'Mid-Sized Manufacturing Company',
         text: "Reliable, knowledgeable, and solution-driven — that's how I would describe Vector Technologies. They've helped us optimize production, reduce operational costs, and modernize our plant. A true partner in innovation."
      },
      {
         id: 10,
         name: 'Operations Team Lead',
         title: 'Industrial Operations',
         text: "Every project we've completed with Vector Technologies has been handled professionally and delivered on schedule. Their ability to diagnose issues and implement efficient automation solutions is remarkable."
      },
   ]

   return (
      <>
         <section className="testimoinal__area gradient-bg" style={{ position: 'relative', overflow: 'hidden' }}>
            <ParticleBackground id="testimonial-particles" variant="light" />
            <div className="container">
               <div className="row">
                  <div className="col-xl-5 col-lg-6">
                     <div className="testimonial__content pt-165 pb-175">
                        <div className="section__title section__title-3 mb-30">
                           <span className="white-color">Testimonials</span>
                           <h2 className="white-color">Featured Client Success Story</h2>
                        </div>

                        <Slider className='testimonial__slider pb-70' {...settings}>

                           {
                              testimonialData.map((testimonial,index) => {
                                 return <div key={index} className="testimonial__item">
                                    <p className="white-color">{testimonial.text}</p>
                                    <div className="testimonial__content d-flex align-items-center">
                                       <div className="quote mr-20">
                                          <img src="assets/img/icon/testimonial/quote.png" alt="quote" />
                                       </div>
                                       <div className="testimonial__info">
                                          <h4 className="white-color">{testimonial.name}</h4>
                                          <span className="white-color">{testimonial.title}</span>
                                       </div>
                                    </div>

                                 </div>
                              })
                           }

                        </Slider>

                     </div>
                  </div>
                  <div className="col-xl-7 col-lg-6">
                     <div className="testimonial__thumb m-img text-end pt-120 " >
                        <img src="assets/img/testimonial/testimonial-1.png" alt="testimonbial" />
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeTwoTestimonial;